interface Props {
  color?: string
  width?: number
  height?: number
}

export const OneSignaIcon = ({
  color = '#000',
  width = 50,
  height = 50,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 280 200"
    >
      <path
        d="M128.344 0C57.58 0 0 57.581 0 128.344c0 45.094 23.588 84.637 58.275 107.531l6.244-4.162c1.387-.694 3.469-2.082 4.856-2.775 2.081-.694 4.163-2.082 5.55-2.775 2.081-.694 4.163-1.388 6.244-2.775 1.387-.694 3.469-1.388 4.856-2.082 2.081-.693 4.856-1.387 6.938-2.081 2.08-.694 3.468-.694 5.55-1.387 2.08-.694 3.468-.694 5.55-1.388 2.08-.694 4.162-.694 6.243-.694 2.082 0 4.857-.693 6.938-.693V138.75h-6.938v-13.875h34.688V216.45c19.425 2.775 36.769 9.713 52.725 19.425 35.381-22.894 58.275-62.437 58.275-107.531C256.688 57.58 199.106 0 128.344 0zM166.5 128.344c0-20.813-17.344-38.156-38.156-38.156-20.813 0-38.156 17.343-38.156 38.156 0 14.569 8.325 27.75 20.812 33.994v7.63c-15.956-6.937-27.75-22.893-27.75-41.624 0-24.975 20.119-45.094 45.094-45.094s45.094 20.119 45.094 45.094c0 15.956-8.325 29.831-20.813 38.156v-8.325c8.325-7.631 13.875-18.037 13.875-29.831zm-13.875 75.619v-7.632c28.444-9.712 48.563-36.768 48.563-68.681 0-39.544-32.607-72.15-72.844-72.15-40.238 0-72.844 32.606-72.844 72.844 0 33.994 23.588 63.131 55.5 70.762v6.938c-35.381-7.631-62.437-39.544-62.437-77.7 0-44.4 35.38-79.781 79.78-79.781s79.782 35.38 79.782 79.78c0 35.382-23.587 65.907-55.5 75.62z"
        fill={color}
      />
    </svg>
  )
}

export const SevenroomsIcon = ({
  color = '#000',
  width = 50,
  height = 50,
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 72 73"
      width={width}
      height={height}
    >
      <g clipPath="url(#a)">
        <path
          fill={color}
          d="M36 0C16.1173 0 0 16.3411 0 36.5S16.1173 73 36 73s36-16.3411 36-36.5S55.8827 0 36 0Zm31.6442 30.7053c0 8.3792-6.6991 15.1713-14.9635 15.1713-8.2643 0-14.9634-6.7921-14.9634-15.1713 0-8.3791 6.6991-15.1713 14.9634-15.1713 8.2644 0 14.9635 6.7922 14.9635 15.1713ZM36 3.4754c9.0358 0 17.2129 3.7316 23.1138 9.7553-2.0035-.7595-4.1724-1.1744-6.4353-1.1744H14.0959C19.8805 6.7242 27.5657 3.4732 36 3.4732v.0022Zm-1.715 27.2299V69.477c-10.8872-.5714-20.359-6.5655-25.844-15.3663l26.0877-26.45a18.9792 18.9792 0 0 0-.2437 3.0446ZM6.7058 50.9549c-2.0996-4.3664-3.278-9.2701-3.278-14.4549 0-7.9597 2.7772-15.262 7.4035-20.966h31.1478a18.4893 18.4893 0 0 0-2.6787 2.3714L6.7058 50.9549ZM37.715 69.4792V41.5511a18.7569 18.7569 0 0 0 2.5849 2.9472l16.8685 17.1028c-5.2882 4.5886-12.0432 7.4882-19.4534 7.8781Zm21.9377-10.2744-9.957-10.0953c.9704.161 1.9654.2448 2.9806.2448 6.6164 0 12.4166-3.5434 15.6566-8.8597-.8564 7.2093-4.0047 13.7022-8.6825 18.7102h.0023Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h72v73H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IntercomIcon = ({
  color = '#000',
  width = 50,
  height = 50,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid"
    >
      <path
        d="M221.867 140.748a8.534 8.534 0 0 1-17.067 0V64a8.534 8.534 0 0 1 17.067 0v76.748zm-2.978 53.413c-1.319 1.129-32.93 27.655-90.889 27.655-57.958 0-89.568-26.527-90.887-27.656a8.535 8.535 0 0 1-.925-12.033 8.53 8.53 0 0 1 12.013-.942c.501.42 28.729 23.563 79.8 23.563 51.712 0 79.503-23.31 79.778-23.545 3.571-3.067 8.968-2.655 12.033.925a8.534 8.534 0 0 1-.923 12.033zM34.133 64A8.534 8.534 0 0 1 51.2 64v76.748a8.534 8.534 0 0 1-17.067 0V64zm42.668-17.067a8.534 8.534 0 0 1 17.066 0v114.001a8.534 8.534 0 0 1-17.066 0v-114zm42.666-4.318A8.532 8.532 0 0 1 128 34.082a8.532 8.532 0 0 1 8.534 8.533v123.733a8.534 8.534 0 0 1-17.067 0V42.615zm42.667 4.318a8.534 8.534 0 0 1 17.066 0v114.001a8.534 8.534 0 0 1-17.066 0v-114zM224 0H32C14.327 0 0 14.327 0 32v192c0 17.672 14.327 32 32 32h192c17.673 0 32-14.328 32-32V32c0-17.673-14.327-32-32-32z"
        fill={color}
      />
    </svg>
  )
}
